import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import { type SdkKey, getSdkInfoByKey } from '@gonfalon/sdk-info/sdkInfo';

export const getSdkDocumentationUrl = (sdk: SdkKey) => {
  const sdkInfo = getSdkInfoByKey(sdk);
  return sdkInfo?.docsPath ? getDocumentationUrl(sdkInfo.docsPath) : getDocumentationUrl('sdk');
};
